var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', {
    staticClass: "c--loyalty-program_badge"
  }, [_c('img', {
    attrs: {
      "src": _vm.imageUrl,
      "width": "44",
      "height": "44",
      "alt": "badge",
      "loading": "lazy"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }